<div class="sc-page">

  <!-- ============================================================
       HERO - dark navy gradient, photo right, floating badges
       ============================================================ -->
  <section class="sc-hero">
    <div class="sc-hero-glow g1"></div>
    <div class="sc-hero-glow g2"></div>

    <div class="sc-container sc-hero-inner">

      <div class="sc-hero-left sc-reveal sc-hidden">
        <!-- <div class="sc-hero-pill">11+ Summer Prep</div> -->

        <h1 class="sc-hero-title">11+ Summer Intensive Course <em></em></h1>

        <!-- <p class="sc-hero-desc">
          Give your child a head start before the new school year. Choose a focused Bootcamp
          or a full Intensive plan, guided by expert tutors and built around real exam boards.
        </p> -->

        <div class="sc-hero-info">
  <div class="sc-hero-price-badge">
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
    <span>Starts <strong>19 July</strong> &nbsp;·&nbsp; As low as <strong class="gold">£9.99/session*</strong></span>
  </div>
  <div class="sc-hero-boards">
    <span class="sc-hero-board-chip">CSSE</span>
    <span class="sc-hero-board-chip">GL</span>
    <span class="sc-hero-board-chip">FSCE</span>
    <span class="sc-hero-board-chip">SET</span>
    <span class="sc-hero-board-chip">ISEB</span>
  </div>
</div>

        <div class="sc-hero-actions">
          <button class="sc-btn-book" (click)="openExternalLink()">
            Register Now
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
          </button>
          <button class="sc-btn-outline" (click)="downloadBrochure()">
            Download Brochure
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
          </button>
        </div>

        
      </div>

      <div class="sc-hero-right sc-reveal sc-hidden d1">
        <div class="sc-hero-img-wrap">
          <img src="https://images.pexels.com/photos/5212324/pexels-photo-5212324.jpeg" alt="Student preparing for 11+ exams" class="sc-hero-img">

          <!-- <div class="sc-hero-badge rating">
            <span class="sc-badge-num">5.0</span>
            <div class="sc-badge-stars">★★★★★</div>
            <span class="sc-badge-label">Trusted by 10,000+ families</span>
          </div> -->

          
        </div>
      </div>

    </div>
  </section>

  <!-- ============================================================
       TRUST / STATS BAR
       ============================================================ -->
  <section class="sc-stats-bar">
    <div class="sc-container sc-stats-inner">
      <div class="sc-stats-text sc-reveal sc-hidden">
        <h2>Your trusted partner</h2>
        <p>From focused revision to full-scale preparation, learn with expert tutors and proven, exam-board aligned materials.</p>
      </div>
      <div class="sc-stats-grid sc-reveal sc-hidden d1">
        <div class="sc-stat">
          <span class="sc-stat-num">10,000+</span>
          <span class="sc-stat-label">Students Guided</span>
        </div>
        <div class="sc-stat">
          <span class="sc-stat-num">1,680+</span>
          <span class="sc-stat-label">Exam Questions</span>
        </div>
        <div class="sc-stat">
          <span class="sc-stat-num">50+</span>
          <span class="sc-stat-label">Certified Tutors</span>
        </div>
      </div>
    </div>
  </section>

  <!-- ============================================================
       WHY / FLEXIBILITY CARDS
       ============================================================ -->
  <section class="sc-flex-section">
    <div class="sc-container">

      <div class="sc-section-header center sc-reveal sc-hidden">

        <h2 class="sc-section-title">Prep That Fits <span>Your Summer</span></h2>
        <p class="sc-section-sub">Whether it's a quick revision boost or a full preparation plan, Sehyog has a course built for your child's needs.</p>
      </div>

      <div class="sc-flex-grid">

        <div class="sc-flex-card sc-reveal sc-hidden">
          <div class="sc-flex-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
          </div>
          <div class="sc-flex-title">Bootcamp: Focused Revision</div>
          <p class="sc-flex-text">8 focused days per subject - perfect for topping up strengths or targeting a specific weak area before results day.</p>
        </div>

        <div class="sc-flex-card highlight sc-reveal sc-hidden d1">
          <div class="sc-flex-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/></svg>
          </div>
          <div class="sc-flex-title">Intensive: Full Preparation</div>
          <p class="sc-flex-text">6–7 weeks of complete 11+ readiness - every subject, every skill, built from the ground up.</p>
        </div>

        <div class="sc-flex-card sc-reveal sc-hidden d2">
          <div class="sc-flex-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
          </div>
          <div class="sc-flex-title">1:1 Doubt-Clearing &amp; PTMs</div>
          <p class="sc-flex-text">Dedicated support sessions and regular parent-teacher meetings so nothing falls through the cracks.</p>
        </div>

      </div>
    </div>
  </section>

  <!-- ============================================================
       COURSE CHOOSER - image-led cards
       ============================================================ -->
 <!-- ============================================================
       COURSE CHOOSER + COMPARISON — merged into one section
       ============================================================ -->
  <section class="sc-chooser" id="courses">
    <div class="sc-container">

      <div class="sc-chooser-header sc-reveal sc-hidden">
        <h2 class="sc-section-title">Choose Your <span>Summer Path</span></h2>
      </div>

      <div class="sc-course-grid">

        <!-- BOOTCAMP CARD -->
        <div class="sc-course-card sc-reveal sc-hidden d1">
          <div class="sc-course-card-img-wrap">
            <img src="https://images.pexels.com/photos/13718859/pexels-photo-13718859.jpeg" alt="Summer Bootcamp course" class="sc-course-card-img">
            <span class="sc-course-tag-float">Summer Bootcamp</span>
          </div>
          <div class="sc-course-card-body2">
            <div class="sc-course-title2">Summer Bootcamp Course</div>
            <p class="sc-course-tagline2">Ideal for focused revision - tackle each subject in depth over 8 days.</p>

            <div class="sc-rating-row">
              <span class="sc-rating-stars">★★★★★</span>
              <span class="sc-rating-score">4.6</span>
              <span class="sc-rating-count">(842)</span>
            </div>

            <div class="sc-meta-row">
              <span class="sc-meta-chip">12 hrs Tuition</span>
              <span class="sc-meta-chip">2 Mock Exams</span>
              <span class="sc-meta-chip">720+ Questions</span>
            </div>

            <a class="sc-course-cta2" [routerLink]="['/summer-bootcamp']">
              View Course
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
            </a>
          </div>
        </div>

        <!-- INTENSIVE CARD -->
        <div class="sc-course-card sc-reveal sc-hidden d2">
          <div class="sc-course-card-img-wrap">
            <img src="https://images.pexels.com/photos/4894734/pexels-photo-4894734.jpeg" alt="Summer Intensive course" class="sc-course-card-img">
            <span class="sc-course-tag-float gold">The Ultimate Prep Plan</span>
          </div>
          <div class="sc-course-card-body2">
            <div class="sc-course-title2">Summer Intensive Course</div>
            <p class="sc-course-tagline2">105 sessions of total confidence - 6 to 7 weeks of comprehensive preparation.</p>

            <div class="sc-rating-row">
              <span class="sc-rating-stars">★★★★★</span>
              <span class="sc-rating-score">4.7</span>
              <span class="sc-rating-count">(1,204)</span>
            </div>

            <div class="sc-meta-row">
              <span class="sc-meta-chip cyan">105 hrs Tuition</span>
              <span class="sc-meta-chip cyan">5 Mock Exams</span>
              <span class="sc-meta-chip cyan">1,680+ Questions</span>
            </div>

            <a class="sc-course-cta2" (click)="scrollToBook()">
              Book Now
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
            </a>
          </div>
        </div>

      </div>

      <!-- Divider into comparison table -->
      <div class="sc-chooser-compare-divider sc-reveal sc-hidden d3">
        <span>Not sure which one? See the full comparison below</span>
      </div>

      <div class="sc-table-wrap sc-reveal sc-hidden d3">
        <table class="sc-table">
          <thead>
            <tr>
              <th style="background:var(--sh-dark)">Feature</th>
              <th class="bootcamp-col">Bootcamp</th>
              <th class="intensive-col">Summer Intensive</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Expert Tuition Hours</td>
              <td>12 hours</td>
              <td>105 hours</td>
            </tr>
            <tr>
              <td>Duration</td>
              <td>8 Days per subject</td>
              <td>6–7 Weeks</td>
            </tr>
            <tr>
              <td>Total Sessions</td>
              <td>12 per subject</td>
              <td>105 sessions</td>
            </tr>
            <tr>
              <td>Assignments &amp; Practice Tests</td>
              <td>12 + 12</td>
              <td>21 + 21</td>
            </tr>
            <tr>
              <td>Exam-Style Questions</td>
              <td>720+</td>
              <td>1,680+</td>
            </tr>
            <tr>
              <td>F2F Mock Exams (CSSE/GL/FSCE)</td>
              <td>2</td>
              <td>5</td>
            </tr>
            <tr>
              <td>Parent-Teacher Meetings (PTM)</td>
              <td>1</td>
              <td>7</td>
            </tr>
            <tr>
              <td>Doubt-Clearing Sessions</td>
              <td>
                <span class="sc-table-check red">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                </span>
              </td>
              <td>21 sessions
                <span class="sc-table-check" style="margin-left:6px">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                </span>
              </td>
            </tr>
            <tr>
              <td>Cohort RAR Report</td>
              <td>
                <span class="sc-table-check">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                </span>
              </td>
              <td>
                <span class="sc-table-check">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                </span>
              </td>
            </tr>
            <tr>
              <td>Pre-Lecture Materials</td>
              <td>
                <span class="sc-table-check">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                </span>
              </td>
              <td>
                <span class="sc-table-check">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                </span>
              </td>
            </tr>
            <tr>
              <td>Best Suited For</td>
              <td>Focused revision, specific subjects</td>
              <td>Full prep from scratch, maximum results</td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
  </section>

  <!-- ============================================================
       WHAT'S INCLUDED IN EVERY COURSE
       ============================================================ -->
  <section class="sc-included">
    <div class="sc-container">

      <div class="sc-included-header sc-reveal sc-hidden">

        <h2 class="sc-section-title">Everything Your Child <span>Needs to Succeed</span></h2>
      </div>

      <div class="sc-included-grid">

        <div class="sc-inc-card sc-reveal sc-hidden">
          <div class="sc-inc-icon gold">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/></svg>
          </div>
          <span class="sc-inc-num">Pre-Lecture</span>
          <div class="sc-inc-title">Materials &amp; Summary Notes</div>
          <p class="sc-inc-text">Ideal for fast, effective revision before each session starts.</p>
        </div>

        <div class="sc-inc-card sc-reveal sc-hidden d1">
          <div class="sc-inc-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>
          </div>
          <span class="sc-inc-num">Proven</span>
          <div class="sc-inc-title">Tips, Tricks &amp; Techniques</div>
          <p class="sc-inc-text">Strategies to decode and tackle the most challenging 11+ questions with confidence.</p>
        </div>

        <div class="sc-inc-card sc-reveal sc-hidden d2">
          <div class="sc-inc-icon cyan">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>
          </div>
          <span class="sc-inc-num cyan">RAR</span>
          <div class="sc-inc-title">Cohort Performance Report</div>
          <p class="sc-inc-text">Standard score, rank, percentile - benchmarked among 150–250 students per cohort.</p>
        </div>

        <div class="sc-inc-card sc-reveal sc-hidden d3">
          <div class="sc-inc-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
          </div>
          <span class="sc-inc-num">Expert</span>
          <div class="sc-inc-title">Parent-Teacher Meetings</div>
          <p class="sc-inc-text">Personalised progress discussions with dedicated guidance for each student.</p>
        </div>

        <div class="sc-inc-card sc-reveal sc-hidden d4">
          <div class="sc-inc-icon gold">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg>
          </div>
          <span class="sc-inc-num">Real</span>
          <div class="sc-inc-title">F2F Mock Exam Papers</div>
          <p class="sc-inc-text">Choose CSSE, FSCE or GL format - papers sat in true exam conditions.</p>
        </div>

        <div class="sc-inc-card sc-reveal sc-hidden d5">
          <div class="sc-inc-icon cyan">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
          </div>
          <span class="sc-inc-num cyan">Always</span>
          <div class="sc-inc-title">Customer Success Support</div>
          <p class="sc-inc-text">Our dedicated team is here every step of the way - from booking to results day.</p>
        </div>

      </div>
    </div>
  </section>

  <!-- ============================================================
       SPLIT - Prep from home, on your schedule
       ============================================================ -->
  <section class="sc-split">
    <div class="sc-container sc-split-inner">

      <div class="sc-split-img-wrap sc-reveal sc-hidden">
        <img src="https://images.pexels.com/photos/5303591/pexels-photo-5303591.jpeg" alt="Student learning online" class="sc-split-img">
      </div>

      <div class="sc-split-content sc-reveal sc-hidden d1">
        <h2 class="sc-section-title">Prep From Home, <span>On Your Schedule</span></h2>
        <p class="sc-split-text">
          Sessions run live online with real tutors - no commuting, no rigid timetables.
          Choose morning, evening or weekend slots that actually fit around your family's summer.
        </p>

        <div class="sc-split-stats">
          <div class="sc-split-stat">
            <span class="sc-split-stat-num">105 hrs</span>
            <span class="sc-split-stat-label">Total Tuition (Intensive)</span>
          </div>
          <div class="sc-split-stat">
            <span class="sc-split-stat-num">21</span>
            <span class="sc-split-stat-label">Assignments &amp; Practice Tests</span>
          </div>
        </div>

        <button class="sc-btn-primary" (click)="scrollToBook()">
          Book Now
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
        </button>
      </div>

    </div>
  </section>

  <!-- ============================================================
       WHY CHOOSE US - numbered list + stacked images
       ============================================================ -->
  <section class="sc-why">
    <div class="sc-container sc-why-inner">

      <div class="sc-why-content sc-reveal sc-hidden">
        <h2 class="sc-section-title">Why Families Choose <span>Sehyog</span> This Summer</h2>
        <p class="sc-split-text" style="margin-bottom:28px">
          Since 2014, Sehyog has guided grammar school hopefuls with a focus on Tajweed-level
          detail, exam-board precision, and real tutor relationships.
        </p>

        <ul class="sc-why-list">
          <li class="sc-why-item">
            <span class="sc-why-num">01</span>
            <div>
              <div class="sc-why-title">Access to Expert 11+ &amp; GCSE Tutors</div>
              <p class="sc-why-text">Sehyog connects you with expert tutors worldwide, so you can choose the fit that works for your child's style and goals.</p>
            </div>
          </li>
          <li class="sc-why-item">
            <span class="sc-why-num">02</span>
            <div>
              <div class="sc-why-title">Personalised Learning Pace</div>
              <p class="sc-why-text">Small cohorts and one-on-one doubt-clearing let students learn at their own pace and revisit lessons whenever they need to.</p>
            </div>
          </li>
          <li class="sc-why-item">
            <span class="sc-why-num">03</span>
            <div>
              <div class="sc-why-title">Cost-Effective, Proven Results</div>
              <p class="sc-why-text">Affordable, convenient courses with exam-board aligned materials - everything your child needs, nothing they don't.</p>
            </div>
          </li>
        </ul>
      </div>

      <div class="sc-why-imgs sc-reveal sc-hidden d1">
        <img src="https://res.cloudinary.com/do7r12azt/image/upload/v1783615379/SCR-20260709-texn_qjksd3.jpg" class="sc-why-img a">
        <img src="https://images.pexels.com/photos/7414958/pexels-photo-7414958.jpeg" alt="Tutor teaching online" class="sc-why-img b">
      </div>

    </div>
  </section>

<!-- ============================================================
       TESTIMONIAL + TRUST
       ============================================================ -->
  <section class="sc-testimonial">
    <div class="sc-container">

      <div class="sc-testi-video-header sc-reveal sc-hidden">
        <p class="sc-eyebrow" style="justify-content:center">Hear It From Them</p>
        <h2 class="sc-section-title light">Happy Parents, <span>Real Results</span></h2>
      </div>

      <div class="sc-testi-video-wrap sc-reveal sc-hidden d1">
        <iframe
          src="https://www.youtube.com/embed/gLnO0THbHTg"
          title="Happy Parents - Sehyog Academy"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen
          class="sc-testi-video-iframe">
        </iframe>
      </div>

      <div class="sc-testi-inner">

        <div class="sc-testi-card sc-reveal sc-hidden">
          <div class="sc-stars">
            <svg class="sc-star" width="20" height="20" viewBox="0 0 24 24" fill="#F5A623" stroke="#F5A623" stroke-width="1"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
            <svg class="sc-star" width="20" height="20" viewBox="0 0 24 24" fill="#F5A623" stroke="#F5A623" stroke-width="1"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
            <svg class="sc-star" width="20" height="20" viewBox="0 0 24 24" fill="#F5A623" stroke="#F5A623" stroke-width="1"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
            <svg class="sc-star" width="20" height="20" viewBox="0 0 24 24" fill="#F5A623" stroke="#F5A623" stroke-width="1"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
            <svg class="sc-star" width="20" height="20" viewBox="0 0 24 24" fill="#F5A623" stroke="#F5A623" stroke-width="1"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
          </div>
          <p class="sc-testi-text">
            "Big thanks to Sanjay and his team for creating such a great platform which was very helpful for our son's 11Plus preparation. We found all the topic wise tests and mock exams well structured and the detailed result analysis helped us understand the weaknesses that we need to work upon. The content is of great quality and really helped boost the confidence prior to real exams."
          </p>
          <div class="sc-testi-name">Sushil Shetty</div>
        </div>

        <div class="sc-testi-right sc-reveal sc-hidden d2">
          <h2 class="sc-testi-heading">
            Join <em>10,000+</em><br>
            Successful<br>
            <span>Students</span>
          </h2>
          <p class="sc-testi-sub">
            Sehyog has been guiding students to grammar school success since 2014. Our summer programmes are rated 5 stars on Trustpilot.
          </p>
          <button class="sc-btn-primary" [routerLink]="['/summer-bootcamp']">
            Book Your Place Today
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
          </button>
        </div>

      </div>
    </div>
  </section>

  <!-- ============================================================
       DARK CTA BANNER
       ============================================================ -->
  <section class="sc-cta-banner">
    <div class="sc-container sc-cta-inner sc-reveal sc-hidden">
      <h2 class="sc-cta-title">Ready to Give Your Child the Edge This Summer?</h2>
      <p class="sc-cta-sub">Limited spaces available across all centres - early bird pricing ends soon.</p>
      <button class="sc-btn-primary lg" (click)="scrollToBook()">
        Book Your Place
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
      </button>
    </div>
  </section>
 

</div>

<!-- Scroll reveal is handled in the component TypeScript -->